import React from 'react'
import { useTranslation } from 'react-i18next'

import { CuppingSession } from '../../types/cuppingSession'
import { CuppingSessionStatus } from '../../types/enums/cuppingSessionStatus'
import { getCuppingSampleCoffeeName, getCuppingSampleLabel } from '../../utils/cuppingUtils'

interface CuppingSampleHeaderProps {
  session: CuppingSession
  index: number
}

const CuppingSampleHeader = (props: CuppingSampleHeaderProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <>{`${t('cupping.sample')} ${getCuppingSampleLabel(props.index)} ${
      props.session.is_blind && props.session.status === CuppingSessionStatus.InProgress
        ? ''
        : `(${getCuppingSampleCoffeeName(props.session.cupping_samples[props.index], t('logview.batch'))})`
    }`}</>
  )
}

export default CuppingSampleHeader
